import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PricingSummary from './pages';

const PricingRouter = () => (
  <Switch>
    <Route path="/pricing/:packageTypes(individual|teams)" component={PricingSummary} />
    <Route path="/pricing" component={PricingSummary} exact />
    <Route path="/pricing/" component={PricingSummary} exact />
  </Switch>
);

export default PricingRouter;
